window.addEventListener("load", function () {
  function initRandomBg(containerSelector) {
    const wrap = document.querySelector(containerSelector);
    if (!wrap) return;

    const bgList = JSON.parse(wrap.dataset.images || '[]');
    if (!bgList.length) return;

    const imgA = wrap.querySelector('img');
    if (!imgA) return;
    const imgB = imgA.cloneNode();
    imgB.classList.remove('is-active');
    imgB.src = '';
    wrap.appendChild(imgB);

    const imgs = [imgA, imgB];
    let current = 0;
    let activeIdx = 0;

    imgA.src = bgList[current];
    imgA.classList.add('is-active');

    setInterval(() => {
      current = (current + 1) % bgList.length;

      const nextIdx = 1 - activeIdx;
      imgs[nextIdx].src = bgList[current];
      imgs[nextIdx].classList.add('is-active');
      imgs[activeIdx].classList.remove('is-active');
      activeIdx = nextIdx;
    }, 5000);
  }

  initRandomBg('#cfl-ms-25-header .random-bg-pc');
  initRandomBg('#cfl-ms-25-header .random-bg');
});
